/** @module AQL/SizeChart/Dimension */
define([
	"dojo/_base/declare",
	"SiteAdmin/DataSheetItemActual"
], function(declare,DataSheetItemActual) {

	return declare(DataSheetItemActual, {
	
		/**
		 * @override
		 * do not use form for ApparelDimension heading on special fi size chart dimension
		 * @param {Context} ctx
		 * @param {Heading} h
		 */
		getBaseHeading: function(ctx, h) {
			// summary: return name heading if special item
			const heading = ctx.__headingName || h;
			heading.noForm = true;
			return heading;
		},
	
		/**
		 * @override
		 * determine whether special unlinked dimension
		 * @param {Context} ctx
		 */
		isSpecial: function(ctx) {	
			if (!ctx.getNodeAttributeValue("Unlinked"))
				return false;
			
			const apparelDimensionURL = ctx.getNodeAttributeValue("ApparelDimension");
			const apparelDimension = ctx.cache.getNode(apparelDimensionURL);
			
			return !apparelDimension || apparelDimension.Special;
		}

	});
});